const commonStyle = {
  state: {
    dialog: {
      width: "550px",
      className: "_beantech-dialog-padding",
      labelWidth: "140px",
      isCenter: true
    },
    table: {
      stripe: false,
      border: true,
      maxHeight: 670
    }
  },

  mutations: {

  },

  actions: {

  }

}

export default commonStyle
